import { useEffect, useState } from "react";

import { PanesContainer, useNotionDatabase } from "dev";

import { TrackingHistoryCard } from "../[uuid]";
import { MockDeliveryStatusProvider } from "@/src/contexts/delivery-status-context";
import { fetchDeliveryStatus } from "@/src/services/dev";
import { DeliveryStatus } from "@/src/types";

export default function HistoricalDup() {
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  const [deliveryStatuses, setDeliveryStatuses] = useState<DeliveryStatus[]>(
    []
  );

  const uuids = ["a91e5b6f-ce24-40e6-a1e6-88b604063b6f"];
  const data = db
    ?.map((r) => ({
      uuid: r["Order UUID"],
      tstamp: r["Order Timestamp"],
      status: r["Status"],
      substatus: r["Sub-status"],
    }))
    .filter((r) => r.uuid && r.tstamp)
    .filter((r) => uuids.includes(r.uuid));

  useEffect(() => {
    data?.forEach((r) => {
      fetchDeliveryStatus(r).then((d) => {
        setDeliveryStatuses((prev) => [...prev, d]);
      });
    });
  }, [data?.length]);

  return (
    <PanesContainer
      items={deliveryStatuses.filter((d) => d.order !== null)}
      renderItem={(deliveryStatus) => (
        <>
          <>
            <span>status: {deliveryStatus.tracking_status.status}</span>
            <span>substatus: {deliveryStatus.tracking_status.substatus}</span>
            <span>uuid: {deliveryStatus.order.uuid}</span>
            <span>
              uuid:{" "}
              {data?.find((d) => d.uuid === deliveryStatus.order.uuid)?.tstamp}
            </span>
          </>

          <pre>
            {JSON.stringify(deliveryStatus?.tracking_history || [], null, 2)}
          </pre>

          <MockDeliveryStatusProvider deliveryStatus={deliveryStatus}>
            <TrackingHistoryCard />
          </MockDeliveryStatusProvider>
        </>
      )}
    />
  );
}
